import React, { memo } from 'react'
import CommonDialog from '../../../../../common/components/dialog/CommonDialog'
import styles from './teammember.module.scss'
import { useDispatch } from 'react-redux'
import { showLoader, hideLoader } from '../../../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'
import { getErrorMessage } from '../../../../../utils/error-handler'
import { UtilityTeamMember } from '../../../../../model/utility-users/utility-team-member'
import { useDeleteTeamMemberInviteMutation } from '../../../../../service/utility-users-service'
import Button from '../../../../../common/components/xepp/button/Button'

type Props = {
    user: UtilityTeamMember
    onCloseDialog: () => void
    onTeamMemberDelete: () => void
}

const CancelTeamMemberDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();
    const [deleteTeamMember, { isLoading }] = useDeleteTeamMemberInviteMutation();
    const handleCancelTeamMemberInvite = async () => {
        
        try {
            dispatch(showLoader());
            await deleteTeamMember(props.user!.id).unwrap();
            props.onTeamMemberDelete();
            toast.success(`Invite for user ${props.user!.email} canceled successfully`)
        } catch (error: any) {
            toast.error(getErrorMessage(error.data) ?? 'An Error occurred');
            
        } finally {
            dispatch(hideLoader());
            props.onCloseDialog();
        }
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={`${styles.container} ${styles.DialogContainer}`}>
                <div className={styles.DialogTitle}>
                    Cancel Team Member Invite
                    <div className={styles.description}>
                        This action cannot be undone.
                    </div>
                </div>
                <div className={styles.DialogBody}>
                    Are you sure you want to cancel invite for team member?
                </div>
                <div className={styles.DialogContainerButtons}>
                    <Button text={'No'} variant={`outline`} onClick={cancel} />
                    <Button text={'Yes'}  disabled={isLoading} onClick={handleCancelTeamMemberInvite} />
                </div>
            </div>
        </CommonDialog>
    )
})

export default CancelTeamMemberDialog